export default __webpack_public_path__ + "static/4-27874a56dcdc0b769d17d595fe91388b.webp";